import { en } from './en';
import { ru } from './ru';
import { no } from './no';

const resources = {
  en: {
    common: en.common,
    home: en.home,
    about: en.about,
    services: en.services,
    testimonials: en.testimonials,
    payment: en.payment,
    info: en.info,
    notfound: en.notfound,
  },
  ru: {
    common: ru.common,
    home: ru.home,
    about: ru.about,
    services: ru.services,
    testimonials: ru.testimonials,
    payment: ru.payment,
    info: ru.info,
    notfound: ru.notfound,
  },
  no: {
    common: no.common,
    home: no.home,
    about: no.about,
    services: no.services,
    testimonials: no.testimonials,
    payment: no.payment,
    info: no.info,
    notfound: no.notfound,
  },
};

export default resources;
